module.exports = __webpack_public_path__ + "static/ALEYA - ICON FINAL (BLACK)-4d20d0e28893ac76de73d6b7adf40590.png";